var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"route route--inner"},[_c('SectionRoute',{attrs:{"color":'main-color',"iconSize":[25, 30],"routes":_vm.renderChildRoutes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }